import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { siteDeviceStatsFetchDataSelector } from 'features/networkAi/selectors'
import { fetchSiteDeviceStatsThunk } from 'features/networkAi/slice'
import { SiteDeviceStats } from 'features/networkAi/types'
import {
  APListViewFrame,
  APListViewColumnHeaderFrame,
  APListViewColumnNameInnerFrame,
  APListViewColumnText,
  APListViewColumnName,
  APListViewColumnMAC,
  APListViewColumnUptime,
  APListViewColumnIP,
  APListViewColumnFirmware,
  APListViewColumnClients,
  APListViewColumnBytes,
  APListViewColumnTrash,
} from './styles'
import { SpinnerCentered } from 'components/Loader'
import APLineItem from './APLineItem'

interface APListViewProps {
  siteId: string
}

function APListView({ siteId }: APListViewProps) {
  const dispatch = useAppDispatch()
  const siteDeviceStats = useAppSelector(siteDeviceStatsFetchDataSelector.data)
  const isLoading = useAppSelector(siteDeviceStatsFetchDataSelector.isFetching)

  useEffect(() => {
    siteId && dispatch(fetchSiteDeviceStatsThunk(siteId))
  }, [dispatch, siteId])

  const siteDeviceStatsSafe: SiteDeviceStats[] = Array.isArray(siteDeviceStats)
    ? siteDeviceStats
    : [{ id: ' ', mac: ' ' } as SiteDeviceStats]

  return (
    <>
      {isLoading ? (
        <SpinnerCentered mt="200px" />
      ) : (
        <APListViewFrame key={siteId}>
          <APListViewColumnHeaderFrame>
            <APListViewColumnName>
              <APListViewColumnNameInnerFrame>
                <APListViewColumnText>Name</APListViewColumnText>
              </APListViewColumnNameInnerFrame>
            </APListViewColumnName>

            <APListViewColumnMAC>
              <APListViewColumnText>MAC Address</APListViewColumnText>
            </APListViewColumnMAC>

            <APListViewColumnFirmware>
              <APListViewColumnText>Firmware Version</APListViewColumnText>
            </APListViewColumnFirmware>

            <APListViewColumnIP>
              <APListViewColumnText>IP Address</APListViewColumnText>
            </APListViewColumnIP>

            <APListViewColumnUptime>
              <APListViewColumnText>Uptime</APListViewColumnText>
            </APListViewColumnUptime>

            <APListViewColumnClients>
              <APListViewColumnText>Clients</APListViewColumnText>
            </APListViewColumnClients>

            <APListViewColumnBytes>
              <APListViewColumnText>Bytes</APListViewColumnText>
            </APListViewColumnBytes>

            <APListViewColumnTrash />
          </APListViewColumnHeaderFrame>
          {siteDeviceStatsSafe.map((siteDeviceStat) => (
            <APLineItem
              key={siteDeviceStat.id}
              siteDeviceStats={siteDeviceStat}
            ></APLineItem>
          ))}
        </APListViewFrame>
      )}
    </>
  )
}

export default APListView
